if (!customElements.get('terms-conditions')) {
  customElements.define(
    'terms-conditions',
    class TermsConditions extends HTMLElement {
      // Shares the checkout button's data-awaiting-checkout-conditions counter
      // with zapiet-picker.js and wonderly-flexi-box.js: each unmet condition
      // holds exactly one count; the button enables only at zero. The button is
      // resolved from the nearest [data-cart-checkout-scope] so the same
      // element works on the cart page footer and inside the cart drawer.
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const scope = this.closest('[data-cart-checkout-scope]') || document;
        const checkoutBtn = scope.querySelector('[data-cart-checkout]');
        const termsAndConditions = this.querySelector('input[type="checkbox"]');
        if (!checkoutBtn || !termsAndConditions) return;

        let held = false;
        const hold = () => {
          if (held) return;
          held = true;
          checkoutBtn.dataset.awaitingCheckoutConditions = (+checkoutBtn.dataset.awaitingCheckoutConditions || 0) + 1;
          checkoutBtn.disabled = true;
        };
        const release = () => {
          if (!held) return;
          held = false;
          const remaining = Math.max(0, (+checkoutBtn.dataset.awaitingCheckoutConditions || 0) - 1);
          checkoutBtn.dataset.awaitingCheckoutConditions = remaining;
          if (remaining === 0) checkoutBtn.disabled = false;
        };

        if (termsAndConditions.checked) release();
        else hold();

        termsAndConditions.addEventListener('change', () => {
          if (termsAndConditions.checked) release();
          else hold();
        });
      }
    }
  );
}
